import { browserHistory } from 'react-router'
import { createVideoFromFiles, loadFile } from '../actions'
import Cookies from 'js-cookie'

export function setCookie(name, value, expires) {
  if (process.env.NODE_ENV === 'development') {
    Cookies.set(name, value, { expires })
  } else {
    Cookies.set(name, value, { expires, domain: '.streamable.com' })
  }
}

export function processUploadedFiles(dispatch, files, group, maxLength) {
  return new Promise((resolve, reject) => {
    function uploadFiles() {
      setCookie('dashboard', 'true', 90000)
      browserHistory.push('/')    

      dispatch(createVideoFromFiles(files), { upload_source: 'web' })
      .then(() => {
        resolve()
      })
    }
    
    if (files.length === 1) {
      const file = files[0]
      getLengthOfVideoFile(file, (duration) => {
        if (duration && duration > (maxLength || 600)) {
          dispatch(loadFile(file, group))
          browserHistory.push('/clipper')
          resolve()
          return
        }
        uploadFiles()
      })
      return
    }
    uploadFiles()
  })
}

export function getVideoFileMetadata(file, callback) {
  const video = document.createElement('video')
  video.preload = 'metadata'
  video.onloadedmetadata = () => {
    callback({
      duration: video.duration,
      height: video.videoHeight,
      width: video.videoWidth,
    })
  }
  video.onerror = () => {
    callback()
  }
  if (typeof file === 'string') {
    video.src = file
  } else {
    video.src = window.URL.createObjectURL(file)
  }
}

export function getLengthOfVideoFile(file, callback) {
  getVideoFileMetadata(file, (data) => {
    if (!data) {
      callback()
      return
    }
    callback(data.duration)
  })
}

export function secondsToString(seconds) {
  const numhours = Math.floor(seconds / 3600)
  seconds -= (numhours * 3600)
  const numminutes = Math.floor(seconds / 60)
  let numseconds = (seconds - (numminutes * 60)).toFixed(2)
  if (numseconds < 10) {
    numseconds = `0${numseconds}`
  }
  if (numhours === 0) {
    if (numminutes > 0) {
      return `${numminutes}:${numseconds}`
    }
    return `0${numseconds}`
  }
  let string = `${numminutes}:${numseconds}`
  if (numminutes < 10) {
    string = `0${string}`
  }
  return `${numhours}:${string}`
}

export function getBestSourceUrl(video) {
  if (video.files) {
    if (video.files.mp4) {
      return video.files.mp4.url
    }
    if (video.files['mp4-mobile']) {
      return video.files['mp4-mobile'].url
    }
  }
  return null
}

export function getFirstFile(video) {
  if (!video.files) {
    return null
  }
  let firstFile = null
  for (const preset of Object.keys(video.files)) {
    const file = video.files[preset]
    if (!firstFile) {
      firstFile = file
    } else if (firstFile.date_added > file.date_added) {
      firstFile = file
    }
  }
  return firstFile
}

export function getEmbedCode(video, options) {

  const { 
    autoplay,
    responsive,
    height,
    width,
    muted,
    tag,
    src,
    poster,
    branding,
    loop,
    skipdelay,
    timeout,
    type,
  } = options
  let code = '<iframe src="https://streamable.com/'
  let aspectRatio = width ? height / width : 0.5625
  
  const { shortcode } = video

  aspectRatio = video.height / video.width
  if (src) {
    code += 'customplayer'
  } else {
    code += `e/${shortcode}`
  }
  if (options.id) {
    code += `/${options.id}`
  }

  const params = []
  if (autoplay) {
    params.push('autoplay=1')
  }
  if (muted) {
    params.push('muted=1')
  }
  if (src) {
    params.push('src=' + encodeURIComponent(src))
    params.push('height=' + video.height.toString())
    params.push('width=' + video.width.toString())
  }
  if (poster) {
    params.push('poster=' + encodeURIComponent(poster))
  }
  if (tag) {
    params.push('tag=' + encodeURIComponent(tag))
  }
  if (branding) {
    params.push('logo=0')
    params.push('rightsholder=' + branding)
  } 
  if (loop === false) {
    params.push('loop=0')
  }
  if (type) {
    params.push('type=' + type)
  }
  if (skipdelay) {
    params.push('skipdelay=' + skipdelay)
  }
  if (timeout) {
    params.push('timeout=' + (timeout * 1000))
  }

  let first = true
  for (const param of params) {
    if (first) {
      code += '?'
    } else {
      code += '&'
    }
    code += param
    first = false
  }
  code += '"'

  if (height && width && !responsive) {
    code = `${code} width="${width}" height="${height}" frameborder="0" allowfullscreen></iframe>`
  } else {
    code = `<div style="width:100%;height:0px;position:relative;padding-bottom:${(aspectRatio * 100).toFixed(3)}%;">${code} frameborder="0" width="100%" height="100%" allowfullscreen style="width:100%;height:100%;position:absolute;left:0px;top:0px;overflow:hidden;"></iframe></div>`
  }
  return code
}

